export enum Permissions {
  CAN_VIEW_MATCHING_ENGINE = 'can_view_moderations',
  CAN_MATCH_ENTITY_PRODUCT_TO_BASE_BOTTLE = 'can_base_bottle_match',
  CAN_UNMATCH_PRODUCT = 'can_unmatch_product',

  CAN_VIEW_BASE_PRODUCTS = 'can_view_base_bottles',
  CAN_MERGE_BASE_PRODUCTS = 'can_base_bottle_merge',
  CAN_CREATE_BASE_PRODUCTS = 'can_create_base_bottle',
  CAN_UPDATE_BASE_PRODUCTS = 'can_update_base_bottle',

  CAN_VIEW_ENTITY_PRODUCTS = 'can_view_products',
  CAN_CREATE_ENTITY_PRODUCT = 'can_create_product',
  CAN_UPDATE_ENTITY_PRODUCT = 'can_update_product',
  CAN_ADD_VARIANT_TO_ENTITY_PRODUCT = 'can_add_variant',
  CAN_DELETE_ENTITY_PRODUCT = 'can_delete_product',
  CAN_BLACKLIST_ENTITY_PRODUCT = 'can_add_to_retailer_product_to_blacklist',
  CAN_REMOVE_BLACKLIST_ENTITY_PRODUCT = 'can_remove_to_retailer_product_from_blacklist',

  CAN_VIEW_PRE_ACCOUNTS = 'can_view_pre_accounts',
  CAN_CREATE_PRE_ACCOUNT = 'can_create_pre_account',
  CAN_UPDATE_PRE_ACCOUNT = 'can_update_pre_account',
  CAN_DELETE_PRE_ACCOUNT = 'can_delete_pre_account',
  CAN_SEARCH_PRE_ACCOUNT = 'can_search_pre_account',
  CAN_PROMOTE_PRE_ACCOUNT = 'can_promote_pre_account',

  CAN_JUMP_TO_BUSINESS = 'can_jump_to_business_admin',

  CAN_VIEW_ACCOUNT = 'can_view_account',
  CAN_ACTIVATE_ACCOUNT = 'can_activate_account',
  CAN_DEACTIVATE_ACCOUNT = 'can_deactivate_account',

  CAN_VIEW_POD_FILES = 'can_view_pod_files',

  CAN_VIEW_REPORTED_ISSUES = 'can_view_retailer_product_report',
  CAN_UPDATE_REPORTED_ISSUE = 'can_update_retailer_product_report',

  CAN_VIEW_BARCODE_RESOLUTION = 'can_view_barcode_resolution',
  CAN_RESOLVE_BARCODE = 'can_resolve_barcode',

  CAN_VIEW_BLACKLISTED_PRODUCTS = 'can_view_retailer_product_blacklist',

  CAN_VIEW_MERGE_JOBS = 'can_view_merge_jobs',
  CAN_REVERT_MERGE_JOBS = 'can_revert_merge_jobs',

  CAN_VIEW_OVERVIEW_ANALYTICS = 'can_view_campaign_statistics',
  CAN_VIEW_BASE_PRODUCT_ANALYTICS = 'can_view_base_bottle_analysis',
  CAN_VIEW_RETAILER_MAP_CHART = 'can_view_retailer_map_chart',
}
